import React from 'react';
import { useTheme } from "@mui/material";
import { Container } from '../home/styles';
import NavBar from '../../components/navbar/navbar';
import { Grid, StyledBox, StyledTypography } from '../services/styles';
import { useNavigate } from 'react-router-dom';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import SchoolIcon from '@mui/icons-material/School';
import TheaterComedyIcon from '@mui/icons-material/TheaterComedy';
import GiteIcon from '@mui/icons-material/Gite';
import LocalDiningIcon from '@mui/icons-material/LocalDining';
import CheckroomIcon from '@mui/icons-material/Checkroom';
import HealthAndSafetyIcon from '@mui/icons-material/HealthAndSafety';
import StorefrontIcon from '@mui/icons-material/Storefront';
import LocalAirportIcon from '@mui/icons-material/LocalAirport';
import VillaIcon from '@mui/icons-material/Villa';
import { verify } from '../../utils/common';

const Agreements: React.FC = () => {
    const theme = useTheme(); 
    const navigate = useNavigate();

    React.useEffect(() => {
        (async () => {
            const currentToken = localStorage.getItem("jwt");
            if (currentToken) {
                const isValid = await verify(currentToken);
                if (isValid.code) {
                    navigate("/unauthorized");
                }
            } else {
                navigate("/unauthorized");
            }
        })();
    }, [navigate]);
    
    return (
        <Container>
            <NavBar active="servicios"/>
            <Grid theme={theme}>
                <StyledBox theme={theme}>
                    <DirectionsCarIcon style={{width:'96px', height: '96px', cursor: 'pointer'}} />
                    <StyledTypography onClick={() => navigate('/agreementList', {state: { agreement: 'autos' },})} fontWeight="bold">Autos</StyledTypography>
                </StyledBox>
                <StyledBox theme={theme}>
                    <SchoolIcon style={{width:'96px', height: '96px', cursor: 'pointer'}} />
                    <StyledTypography onClick={() => navigate('/benefits')} fontWeight="bold">Educación</StyledTypography>
                </StyledBox>
                <StyledBox theme={theme}>
                    <TheaterComedyIcon style={{width:'96px', height: '96px', cursor: 'pointer'}} />
                    <StyledTypography onClick={() => navigate('/benefits')} fontWeight="bold">Entretenimiento</StyledTypography>
                </StyledBox>
                <StyledBox theme={theme}>
                    <GiteIcon style={{width:'96px', height: '96px', cursor: 'pointer'}} />
                    <StyledTypography onClick={() => navigate('/benefits')} fontWeight="bold">Hogar</StyledTypography>
                </StyledBox>
                <StyledBox theme={theme}>
                    <LocalDiningIcon style={{width:'96px', height: '96px', cursor: 'pointer'}} />
                    <StyledTypography onClick={() => navigate('/benefits')} fontWeight="bold">Restaurantes</StyledTypography>
                </StyledBox>
                <StyledBox theme={theme}>
                    <CheckroomIcon style={{width:'96px', height: '96px', cursor: 'pointer'}} />
                    <StyledTypography onClick={() => navigate('/benefits')} fontWeight="bold">Ropa & Accesorios</StyledTypography>
                </StyledBox>
                <StyledBox theme={theme}>
                    <HealthAndSafetyIcon style={{width:'96px', height: '96px', cursor: 'pointer'}} />
                    <StyledTypography onClick={() => navigate('/benefits')} fontWeight="bold">Salud</StyledTypography>
                </StyledBox>
                <StyledBox theme={theme}>
                    <StorefrontIcon style={{width:'96px', height: '96px', cursor: 'pointer'}} />
                    <StyledTypography onClick={() => navigate('/benefits')} fontWeight="bold">Tiendas Especializadas</StyledTypography>
                </StyledBox>
                <StyledBox theme={theme}>
                    <LocalAirportIcon style={{width:'96px', height: '96px', cursor: 'pointer'}} />
                    <StyledTypography onClick={() => navigate('/benefits')} fontWeight="bold">Viajes</StyledTypography>
                </StyledBox>
                <StyledBox theme={theme}>
                    <VillaIcon style={{width:'96px', height: '96px', cursor: 'pointer'}} />
                    <StyledTypography onClick={() => navigate('/benefits')} fontWeight="bold">Vivienda</StyledTypography>
                </StyledBox>
            </Grid>
        </Container>
    )
}

export default Agreements;